/** Mensagem do toast quando a tela do PIX é cancelada; fechar pelo usuário não mostra toast. */
export const pixCancelToastMessage = (message: string | undefined): string | undefined =>
	message && !message.includes("Fechado pelo usuário") ? message : undefined;
